import React, { Suspense } from 'react';
import { useParams } from 'react-router-dom';

import { SettingsPageFrame, TableSkeleton } from '@eluve/blocks';
import { useTranslation } from '@eluve/i18n';

import { SessionTypesTable } from './SessionTypesTable';

export const SessionTypesPage: React.FC = () => {
  const { tenantId } = useParams() as { tenantId: string };
  const { t } = useTranslation();

  return (
    <SettingsPageFrame size="wide" title={t('tenantAdmin.sessionTypes.title')}>
      <Suspense fallback={<TableSkeleton rowCount={10} />}>
        <SessionTypesTable tenantId={tenantId} />
      </Suspense>
    </SettingsPageFrame>
  );
};
